import { Client, Repository } from "./client";
import URI from "urijs";
import Session from "session";
import { ClientConfiguration } from "client/client";
import octopusDynamicExtensions from "areas/dynamicExtensions";

const browserURI = URI(window.location);
const configuration: ClientConfiguration = {
    serverEndpoint: null,
};

browserURI.hasQuery("octopus.server", (octopusServerURI: string) => {
    configuration.serverEndpoint = octopusServerURI;
});

octopusDynamicExtensions.setApiDocumentRootUrl(configuration.serverEndpoint + "/api");

const client = Client.Create(configuration);
const repository = new Repository(client);
const session = new Session();

export { client, repository, session };
